import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";

@Component({
	selector: "obg-m-customer-service-link",
	templateUrl: "customer-service-link.component.html",
	styleUrls: ["./customer-service-link.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerServiceLinkComponent {
	@HostBinding("class.obg-m-verification-code-actions-customer-service-action") hostCssClass = true;

	@Input() messageKey: string | undefined;

	@Output() customerSupportClick = new EventEmitter<void>();
}
